import { memo } from "react";

const comparisons = [
  {
    feature: "Benchmarking",
    traditional: "Static, outdated industry reports",
    aimaa: "Real-time, industry-specific data benchmarks"
  },
  {
    feature: "Insights",
    traditional: "Generic recommendations",
    aimaa: "AI-powered, personalized action plans"
  },
  {
    feature: "Industry Focus",
    traditional: "One-size-fits-all approach",
    aimaa: "Tailored to specific industry contexts"
  },
  {
    feature: "Updates",
    traditional: "Annual or bi-annual updates",
    aimaa: "Continuous adaptation to AI trends"
  },
  {
    feature: "Methodology",
    traditional: "Fixed assessment criteria",
    aimaa: "Dynamic, evolving evaluation model"
  },
  {
    feature: "Support",
    traditional: "Basic report generation",
    aimaa: "Ongoing progress tracking & guidance"
  }
] as const;

const ComparisonSectionComponent = () => {
  return (
    <section className="py-12 sm:py-20 bg-gradient-to-br from-[#0f2d69]/5 via-white to-[#0f2d69]/5">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#0f2d69] text-center mb-8 sm:mb-12 animate-fade-in">
          How AIMAA Compares
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {comparisons.map((comparison, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <h3 className="text-lg sm:text-xl font-semibold mb-4 text-[#0f2d69]">
                {comparison.feature}
              </h3>
              <div className="space-y-4">
                <div className="p-4 bg-gray-50 rounded-lg transform transition-transform duration-300 hover:scale-102">
                  <p className="text-xs sm:text-sm text-gray-500 mb-2">Traditional Models</p>
                  <p className="text-sm sm:text-base text-gray-600">{comparison.traditional}</p>
                </div>
                <div className="p-4 bg-[#0f2d69]/5 rounded-lg transform transition-transform duration-300 hover:scale-102">
                  <p className="text-xs sm:text-sm text-[#0f2d69] mb-2">AIMAA Approach</p>
                  <p className="text-sm sm:text-base text-gray-600">{comparison.aimaa}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ComparisonSection = memo(ComparisonSectionComponent);
export default ComparisonSection;
